import { QueryKeys } from "@/constants/Query";
import { useApiMutation } from "@/hooks/useApiMutation";
import axiosInstance from "@/lib/axios";
import { useQueryClient } from "@tanstack/react-query";
import type * as fhirTypes from "fhir/r4";

interface UpdateSubjectiveParams {
  subjectiveText: string;
  addedAddendumIds: string[];
  addedAddendumExtensionIds: string[];
}

interface UpdateSubjectiveResponse {
  documentReferences: fhirTypes.DocumentReference[];
}

export const useUpdateSubjective = ({
  patientId,
  encounterId,
  docRefId,
}: { patientId?: string; encounterId?: string; docRefId?: string }) => {
  const queryClient = useQueryClient();

  return useApiMutation<UpdateSubjectiveResponse, UpdateSubjectiveParams>({
    mutationOptions: {
      mutationKey: QueryKeys.Patient.Chart.Subjective.UPDATE(
        patientId,
        docRefId,
      ),
      mutationFn: (params) => {
        return axiosInstance.patch(`/charting/subjective/${docRefId}`, params);
      },
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: QueryKeys.Patient.Chart.Subjective.DEFAULT({
            patientId,
            encounterId,
          }),
        });

        queryClient.invalidateQueries({
          queryKey: QueryKeys.Patient.MedicalRecords.Timeline.ENCOUNTER({
            patientId,
            motherEncounterId: encounterId,
          }),
        });
      },
    },
  });
};
